module.exports = __webpack_public_path__ + "2b018026dcec3a359b1976684a54e2ec.svg";